export const COUPONS_TABLE_HEAD = [
  { id: 'code', label: 'Code', align: 'left' },
  { id: 'user_id', label: 'User', align: 'left' },
  { id: 'description', label: 'Description', align: 'left' },
  { id: 'value', label: 'Value', align: 'left' },
  { id: 'usage_limit', label: 'Limit', align: 'left' },
  { id: 'drip_sessions', label: 'Drip Sessions', align: 'left' },
  { id: 'coupon_platform.name', label: 'Platforms', align: 'left' },
  { id: 'start_date', label: 'Valid', align: 'left' },
  { id: 'active', label: 'Status' },
  { id: '3-dot-menu' },
];
